// removed by extract-text-webpack-plugin
module.exports = {"label":"waYgBOhT0GDsMI9LLT0ms","primaryText":"tUrjDEpwKWutdzjkXmtmp","secondaryText":"_3BIasPL6kcJTCqNVA5_sU5","headerText":"_1zu6tz4EeeMNV4wyUQmp5u","error":"_1TAm4-gGU3ZleAuSoqbqa8","warning":"_25WyWN9_J3Qn86rLmGQGKZ","success":"_3oQIuJapfm7GVjICVLkopf"};


//////////////////
// WEBPACK FOOTER
// ./client/src/styles/Typography.scss
// module id = 398
// module chunks = 0